"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));
var LoadingMessage = function LoadingMessage(_ref) {
  var _ref$commonProps = _ref.commonProps,
    automationid = _ref$commonProps.automationid,
    dataMetrics = _ref$commonProps.dataMetrics,
    loadingMessage = _ref.componentProps.loadingMessage;
  return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
    automationid: "".concat(automationid, "-loading-message"),
    component: "div",
    "data-metrics": dataMetrics.loadingMessage,
    disabled: true,
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    noWrap: true,
    variant: "body1"
  }, loadingMessage));
};
LoadingMessage.propTypes = process.env.NODE_ENV !== "production" ? {
  commonProps: _propTypes["default"].object,
  componentProps: _propTypes["default"].object
} : {};
var _default = LoadingMessage;
exports["default"] = _default;